export const DS_SELECT_CLASSES = {
  Root: "ds-select",
  SelectedOptions: "ds-select__selected-options",
};
